import Store from "@/store/index.js";
import axios from "axios";
const domain = Store.state.domain;


export default {
    TotalesPendientes(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/TotalesPendientes`, data).then(response => response.data);
    },
    ReportesPendientesAdjuntar(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/ReportesPendientesAdjuntar`, data).then(response => response.data);
    },
    TotalesPrimerContacto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/TotalesPrimerContacto`, data).then(response => response.data);
    },
    //ReportesAdjuntadosver(vm, data) {
    //    return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/ReportesAdjuntadosver`, data).then(response => response.data);
    //},
    SinPrimerContacto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/SinPrimerContacto`, data).then(response => response.data);
    },
    PrimerContactoResNO(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}MisPendientes/PrimerContactoResNO`, data).then(response => response.data);
    },


    MisPendientesGRALExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesGRALExcel`,
                formData
            )
            .then((response) => response.data);
    },
    MisPendientesContactoExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesContactoExcel`,
                formData
            )
            .then((response) => response.data);
    },
    MisPendientesTerminoExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesTerminoExcel`,
                formData
            )
            .then((response) => response.data);
    },
    MisPendientesvhdetExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesvhdetExcel`,
                formData
            )
            .then((response) => response.data);
    },
    MisPendientesTam(vm, data, sp) {


        let numRegServ = 0;

        if (data.numReg == 0) {
            numRegServ = 20;
        }
        else {
            numRegServ = data.numReg;
        }

        var formData = new FormData();
        formData.append("numreg", numRegServ);
        formData.append("sp", sp);


        return axios.post(`${domain.domainNameForApi}MisPendientes/ObtenerTam`, formData).then((response) => response.data);
    },


    MisPendientesContactoCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesContactoCards`
            )
            .then((response) => response.data);
    },


    MisPendientesTerminoCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesTerminoCards`
            )
            .then((response) => response.data);
    },

    MisPendientesVhDetCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesVhDetCards`
            )
            .then((response) => response.data);
    },


    MisPendientesSolDocExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesSolicitudDocumentosExcel`,
                formData
            )
            .then((response) => response.data);
    },


    //MisPendientesMontosPensionMultasGruaExcel
    MisPendientesMonPenMulGruaExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesMontosPensionMultasGruaExcel`,
                formData
            )
            .then((response) => response.data);
    },

    MisPendientesRecepcionDocumentosExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesRecepcionDocumentosExcel`,
                formData
            )
            .then((response) => response.data);
    },


    MisPendientesPagPenMulGruaExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/PG_MisPendientes_PagosPensionMultasGrua_Excel`,
                formData
            )
            .then((response) => response.data);
    },


    MisPendientesConDetenidoCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesConDetenidoCards`
            )
            .then((response) => response.data);
    },


    MisPendientesConDetenidoExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesConDetenidoExcel`,
                formData
            )
            .then((response) => response.data);
    },


    MisPendientesPeritajeFavCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPeritajeFavCards`
            )
            .then((response) => response.data);
    },

    MisPendientesPeritajeFavExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPeritajeFavExcel`,
                formData
            )
            .then((response) => response.data);
    },



    //Robo


    MisPendientesRoboCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesRoboCards`
            )
            .then((response) => response.data);
    },

    MisPendientesRoboExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesRoboExcel`,
                formData
            )
            .then((response) => response.data);
    },


    MisPendientesRoboSolDocExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesRoboSolicitudDocumentosExcel`,
                formData
            )
            .then((response) => response.data);
    },


    MisPendientesRoboRecDocExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesRoboRecepcionDocumentosExcel`,
                formData
            )
            .then((response) => response.data);
    },


    //Autorizar
    MisPendientesPendAutorizarExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendAutorizarExcel`,
                formData
            )
            .then((response) => response.data);
    },

    MisPendientesPendAutorizarCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendAutorizarCards`
            )
            .then((response) => response.data);
    },

    //Sin concluir
    MisPendientesPendientesSinConcluirExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendientesSinConcluirExcel`,
                formData
            )
            .then((response) => response.data);
    },

    MisPendientesPendientesSinConcluirCards() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendientesSinConcluirCards`
            )
            .then((response) => response.data);
    },

    //Rechadada

    MisPendientesConclusionRecExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendientesConclusionRec`,
                formData
            )
            .then((response) => response.data);
    },

    //SinVolanteJuridico

    MisPendientesSinVolanteJuridico(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesSinVolanteJurExcel`,
                formData
            )
            .then((response) => response.data);
    },

    //Dias sin mov
    MisPendientesDiasSinMovimientoExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesDiasSinMovimientoExcel`,
                formData
            )
            .then((response) => response.data);
    },

    MisPendientesDiasSinMovCard() {

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesDiasSinMovCard`
            )
            .then((response) => response.data);
    },


    //Asuntos Relevantes
    MisPendientesAsuntosRelevantesExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesAsuntosRelevantesExcel`,
                formData
            )
            .then((response) => response.data);
    },

    //Llamadas CI
    MisPendientesLlamadasCIExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesLlamadasCIExcel`,
                formData
            )
            .then((response) => response.data);
    },

    //Negociaciones
    MisPendientesPendienteCapturar(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendienteCapturarExcel`,
                formData
            ).then((response) => response.data);
    },

    MisPendientesPendienteAutorizarExcel(vm, data) {

        var formData = new FormData();
        formData.append("suclave", data.suclave);
        formData.append("geclave", data.geclave);
        formData.append("ejeclave", data.ejeclave);
        formData.append("status", data.status);
        formData.append("prclave", data.prclave);

        return axios
            .post(
                `${domain.domainNameForApi}MisPendientes/MisPendientesPendienteAutorizarExcel`,
                formData
            ).then((response) => response.data);
    },

    async MisPendientesAsistenciaCivilExcel(vm, data) {
        let response = await axios.post(`${domain.domainNameForApi}MisPendientes/MisPendientesAsistenciaCivilExcel`)
        return response.data
    },
    async MisPendientesDocValidarExcel() {
        let response = await axios.post(`${domain.domainNameForApi}MisPendientes/MisPendientesDocValidarExcel`)
        return response.data
    },
    async MisPendientesDocRechazadosExcel() {
        let response = await axios.post(`${domain.domainNameForApi}MisPendientes/MisPendientesDocRechazadosExcel`)
        return response.data
    }
}